var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEllipsisVerticalSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ellipsis-vertical-solid",
    xmlns: "http://www.w3.org/2000/svg",
    width: 6.223,
    height: 24,
    viewBox: "0 0 6.223 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ellipsis-vertical-solid-2",
    "data-name": "ellipsis-vertical-solid",
    d: "M11.111,57.778A3.111,3.111,0,1,1,8,60.889,3.113,3.113,0,0,1,11.111,57.778Zm0-8.889A3.111,3.111,0,1,1,8,52,3.113,3.113,0,0,1,11.111,48.889Zm3.111-5.778A3.111,3.111,0,1,1,11.111,40,3.113,3.113,0,0,1,14.222,43.111Z",
    transform: "translate(-8 -40)",
    fill: "#ccd0d1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipsisVerticalSolid);
export default __webpack_public_path__ + "static/media/ellipsis-vertical-solid.b6b9acc204438e24b2848bba63208365.svg";
export { ForwardRef as ReactComponent };